import React from 'react'
import toshibaCassetteSPIClassic from "../images/spi-classic-banner-3.png";
import toshibapi_premier from "../images/premier (1).png"
function ToshibaSlider() {
  return (
    <div>
        <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={toshibaCassetteSPIClassic} className="d-block w-100" alt="toshibaCassetteSPIClassic"/>
    </div>
    <div className="carousel-item">
      <img src={toshibapi_premier} className="d-block w-100" alt="toshibapi-premier"/>
    </div>
 
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default ToshibaSlider